var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #ebebeb;\n      }\n\n      .cls-5 {\n        fill: #f1672a;\n      }\n\n      .cls-6 {\n        fill: #fee7e2;\n      }\n\n      .cls-7 {\n        fill: #e44f26;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.8,19.9l-6,66.7-26.8,7.4-26.7-7.4L10.3,19.8h65.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.1,88.4l21.6-6,5.1-57h-26.7v63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.6,41.7h11.6v-8.2h-20.5l.2,2.2,2,22.6h18.3v-8.2h-10.8l-.7-8.4h0ZM33.4,62.4h-8.2l1.1,12.9,16.8,4.7h0v-8.5h0l-9.1-2.5-.6-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,1.7h4.2v4.1h3.8V1.7h4.2v12.4h-4.2v-4.2h-3.8v4.2h-4.2V1.7h0ZM34.1,5.9h-3.7V1.7h11.5v4.1h-3.7v8.3h-4.2V5.9h.1ZM43.8,1.7h4.3l2.7,4.4,2.7-4.4h4.3v12.4h-4.1v-6.2l-2.9,4.4h0l-2.9-4.4v6.2h-4.1V1.7ZM59.9,1.7h4.2v8.3h5.9v4.1h-10V1.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.1,58.3h10.1l-1,10.6-9.1,2.5v8.5l16.8-4.7v-1.4c0,0,2-21.6,2-21.6l.2-2.2h-19v8.2h0ZM43.1,41.7h19.8l.2-1.8.4-4.2.2-2.2h-20.5v8.2h-.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.e8e9ef7a0a0da46e0e127ce10e2032d0.svg";
export { ForwardRef as ReactComponent };